import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3520238999/src/covid-frontend/components/auth/resend-activation-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getSession"] */ "/codebuild/output/src3520238999/src/covid-frontend/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3520238999/src/covid-frontend/node_modules/next/dist/client/link.js");
